import { useCallback, useRef } from 'react';
import { useState } from 'react';
import { safeParseJSONNotRef } from '../utils/jsonValidator';
import { resolveActionConfig } from '../helpers/configResolver';

export function useResolveBodyData(body_data = {}) {
    const [bodyData, setbodyData] = useState(() => safeParseJSONNotRef(body_data));
    const initialRef = useRef(safeParseJSONNotRef(body_data));

    const setBodyData = useCallback((newData) => {
        const parsed = safeParseJSONNotRef(newData);
        setbodyData(parsed);
        initialRef.current = safeParseJSONNotRef(parsed);
    }, []);

    const getTemplate = useCallback(() => safeParseJSONNotRef(initialRef.current), []);

    const templateHasPlaceholder = useCallback((token) => {
        try {
            const template = JSON.stringify(initialRef.current);
            return template.includes(`{${token}}`) || template.includes(`{[form].${token}}`);
        } catch {
            return false;
        }
    }, []);

    /**
     * Always resolves from a clone of the original template when fromScratch is true
     * so {placeholders} are never permanently consumed.
     * @param {Object} values - Primary source (form). Empty strings win over secondary.
     * @param {string|null} key - Optional prefix for nested select objects.
     * @param {boolean} fromScratch - Resolve from original bodyData template (avoids baked-in values).
     * @param {Object} secondarySource - Fallback source (e.g. dtoReg + companyInfo).
     */
    const resolveInfo = useCallback((values, key = null, fromScratch = true, secondarySource = {}) => {
        const baseData = safeParseJSONNotRef(fromScratch ? initialRef.current : bodyData);
        const finalObj = resolveActionConfig(baseData, values, secondarySource, key);

        setbodyData(finalObj);
        return finalObj;
    }, [bodyData]);

    const resetInit = useCallback(() => {
        setbodyData(safeParseJSONNotRef(initialRef.current));
    }, []);

    return { bodyData, resolveInfo, resetInit, setBodyData, getTemplate, templateHasPlaceholder };
}
